import React, { useState, useEffect, useImperativeHandle, useRef } from "react";
import Select from "react-select"; // Import from react-select
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import DoNotDisturbOnRoundedIcon from "@mui/icons-material/DoNotDisturbOnRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { useSelector } from "react-redux";

const conditionOptions = [{ value: "win", label: "Win" }];

const ActionStandardKPI = React.forwardRef(function ActionStandardKPI({ tabId, getAsKpiData, options, formData = [], removeKpiCondition = () => { }, validation = {}, isHomeUseTest = false }, ref) {
    const inputRef = useRef(null);
    const inputRefIf = useRef([]);
    const [ifSelects, setIfSelects] = useState([""]);
    const [elIfSelects, setElIfSelects] = useState([""]);

    const [ifMin, setIfMin] = useState(1);
    const [elIfMin, setElIfMin] = useState(1);
    const [showElIf, setShowElIF] = useState(true);
    const [ren, setRen] = useState(true);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = isHairCare || isSkinCare;

    // Check if any KPI is selected in IF block (string-based KPIs)
    const isIfKpiSelected = ifSelects.some((item) => item && item.trim() !== "");

    // Sync sample size data from IF to ELSE-IF when ELSE-IF is enabled
    useEffect(() => {
        if (isIfKpiSelected && showElIf && elIfMin === 1 && ifMin !== elIfMin) {
            setElIfMin(ifMin);
        }
    }, [isIfKpiSelected, ifMin, showElIf, elIfMin]);

    const normalizeKpis = (kpis) =>
        isBeautyAndWellbeing || isHomeUseTest
            ? kpis.map((bv) => (bv !== null && typeof bv === "object" && "backend_variable" in bv ? bv.backend_variable : bv))
            : kpis;

    useEffect(() => {
        if (ren && formData.length) {
            const _ifData = formData.filter((ele) => ele?.is_if === true)?.[0];
            if (_ifData) {
                if (_ifData?.kpi.length !== 0)
                    setIfSelects(normalizeKpis(_ifData?.kpi));
                setIfMin(_ifData?.min || 1);
            }

            const _elseIfData = formData.filter((ele) => ele?.is_if === false)?.[0];
            if (_elseIfData) {
                if (_elseIfData?.kpi.length !== 0)
                    setElIfSelects(normalizeKpis(_elseIfData?.kpi));
                setElIfMin(_elseIfData?.min || 1);
            } else {
                setShowElIF(false);
            }
        }
    }, [formData, ren]);

    useImperativeHandle(ref, () => ({
        clearValue() {
            setRen(false);
            if (inputRef.current) {
                inputRef.current.value = ""; // Clears the input's value
            }
            setIfSelects([""]);
            setElIfSelects([""]);
        },
    }));
    // useEffect(() => {
    //     let ifKpi = ifSelects.map((ele) => ele.kpi?.value).filter(Boolean);
    //     let elIfKpi = elIfSelects.map((ele) => ele.kpi?.value).filter(Boolean);
    //     let payload = [];

    //     payload.push({
    //         kpi: ifKpi,
    //         min: parseInt(ifMin),
    //         max: parseInt(ifKpi.length),
    //         expected_result: conditionOptions[0]?.value,
    //         is_if: true
    //     });

    //     if(showElIf){

    //         payload.push({
    //             kpi: elIfKpi,
    //             min: parseInt(elIfMin),
    //             max: parseInt(elIfKpi.length),
    //             expected_result: elIfCondition?.value,
    //             is_if: false
    //         });

    //     }
    //     getAsKpiData(tabId, payload);
    // }, [ifSelects, elIfSelects, ifMin, elIfMin, ifCondition, elIfCondition]);

    // useEffect(() => {
    //     if (formData?.length > 0) {
    //         if(formData.length === 1){
    //             setShowElIF(false);
    //         }
    //         formData?.forEach((datum) => {
    //             const kpiData = datum?.kpi != "" ? JSON.parse(datum?.kpi) : [""];
    //             if(datum.is_if){
    //                 let ifKpis = kpiData.map((ele) => {
    //                     return { kpi: options?.find(obj => obj.value === ele) }
    //                 });

    //                 setIfSelects(ifKpis);
    //                 setIfMin(datum.min);
    //                 setIfCondition(conditionOptions.find(obj => obj.value === datum.expected_result));
    //             } else {
    //                 let elIfKpis = kpiData.map((ele) => {
    //                     return { kpi: options?.find(obj => obj.value === ele) }
    //                 });
    //                 setElIfSelects(elIfKpis);
    //                 setElIfMin(datum.min);
    //                 setElIfCondition(conditionOptions.find(obj => obj.value === datum.expected_result));
    //             }
    //         });

    //     }
    // }, [options])

    const handleAddSelect = (type) => {
        // Add a new Select component to the current state
        if (type === "if") {
            setIfSelects([...ifSelects, ""]);
        } else {
            setElIfSelects([...elIfSelects, ""]);
        }
    };

    // Function to remove a select component based on the index
    // const handleRemoveSelect = (type, index) => {
    //     // Filter out the select component at the given index
    //     if (type === "if") {
    //         if(ifSelects.length <= ifMin){
    //             setIfMin(1);
    //         }
    //         setIfSelects(ifSelects.filter((_, i) => i !== index));
    //         getAsKpiData(tabId, obj, true)
    //     } else {
    //         if(elIfSelects.length <= elIfMin){
    //             setElIfMin(1);
    //         }
    //         setElIfSelects(elIfSelects.filter((_, i) => i !== index));
    //     }
    //     getFilteredOptions();
    // };

    // Function to handle change in Select box (if needed)
    const handleSelectChange = (value, index, type, block, remove = false) => {
        setRen(false);
        if (remove) {
            if (block === "if") {
                if (ifSelects.length <= ifMin) {
                    setIfMin(1);
                }
                const val = ifSelects.filter((_, i) => i !== index);
                setIfSelects(val);

                const obj = JSON.parse(JSON.stringify(formData.filter((ele) => ele?.is_if == true)?.[0] || {}));
                obj["expected_result"] = conditionOptions[0].value;
                obj["is_if"] = true;
                obj["min"] = 1;
                obj["kpi"] = val.map((ele) => ele).filter(Boolean);
                obj["max"] = val.map((ele) => ele).filter(Boolean).length;
                getAsKpiData(tabId, obj, true);
            } else {
                if (elIfSelects.length <= elIfMin) {
                    setElIfMin(1);
                }

                const val = elIfSelects.filter((_, i) => i !== index);
                setElIfSelects(val);

                const obj = JSON.parse(JSON.stringify(formData.filter((ele) => ele?.is_if == false)?.[0] || {}));
                obj["expected_result"] = conditionOptions[0].value;
                obj["is_if"] = false;
                obj["min"] = 1;
                obj["kpi"] = val.map((ele) => ele).filter(Boolean);
                obj["max"] = val.map((ele) => ele).filter(Boolean).length;
                getAsKpiData(tabId, obj, false);
            }
            getFilteredOptions();
        } else {
            if (block === "if") {
                const obj = JSON.parse(JSON.stringify(formData.filter((ele) => ele?.is_if == true)?.[0] || {}));
                obj["expected_result"] = conditionOptions[0].value;
                obj["is_if"] = true;
                obj["min"] = ifMin;

                if (type === "inputMin") {
                    setIfMin(value);
                    obj["min"] = parseInt(value);
                }

                if (type === "selectKpi") {
                    const val = ifSelects.map((ele, i) => (i !== index ? ele : value.value));
                    setIfSelects(val);
                    obj["kpi"] = val.map((ele) => ele).filter(Boolean);
                    obj["max"] = val.map((ele) => ele).filter(Boolean).length;
                }
                getAsKpiData(tabId, obj, true);
            } else if (block === "elseIf") {
                const obj = JSON.parse(JSON.stringify(formData.filter((ele) => ele?.is_if == false)?.[0] || {}));
                obj["expected_result"] = conditionOptions[0].value;
                obj["is_if"] = false;
                obj["min"] = elIfMin;

                if (type === "inputMin") {
                    setElIfMin(value);
                    obj["min"] = parseInt(value);
                }

                if (type === "selectKpi") {
                    const val = elIfSelects.map((ele, i) => (i !== index ? ele : value.value));
                    obj["kpi"] = val.map((ele) => ele).filter(Boolean);
                    obj["max"] = val.map((ele) => ele).filter(Boolean).length;
                    setElIfSelects(val);
                }

                getAsKpiData(tabId, obj, false);
            }
        }
    };

    const renderAddRemoveKPIButtons = (type, index, selects) => {
        let buttons = "";
        if (selects.length === 1) {
            if (type === "if") {
                if (showElIf) {
                    buttons = "";
                } else {
                    buttons = (
                        <IconButton
                            onClick={() => handleAddSelect(type)}
                            aria-label="add"
                            sx={{
                                color: "rgb(51, 94, 234) !important",
                            }}
                        >
                            <AddCircleRoundedIcon
                                style={{
                                    fontSize: 20,
                                }}
                            />
                        </IconButton>
                    );
                }
            } else {
                buttons = (
                    <IconButton
                        onClick={() => handleAddSelect(type)}
                        aria-label="add"
                        sx={{
                            color: "rgb(51, 94, 234) !important",
                        }}
                    >
                        <AddCircleRoundedIcon
                            style={{
                                fontSize: 20,
                            }}
                        />
                    </IconButton>
                );
            }
        } else {
            if (index === selects.length - 1) {
                buttons = (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                        }}
                    >
                        <IconButton
                            onClick={() => handleSelectChange(null, index, null, type, true)}
                            aria-label="close"
                            sx={{
                                color: "#ff0000b8 !important",
                            }}
                        >
                            <DoNotDisturbOnRoundedIcon
                                style={{
                                    fontSize: 20,
                                }}
                            />
                        </IconButton>
                        <IconButton
                            onClick={() => handleAddSelect(type)}
                            aria-label="add"
                            sx={{
                                color: "rgb(51, 94, 234) !important",
                            }}
                        >
                            <AddCircleRoundedIcon
                                style={{
                                    fontSize: 20,
                                }}
                            />
                        </IconButton>
                    </div>
                );
            } else {
                buttons = (
                    <IconButton
                        onClick={() => handleSelectChange(null, index, null, type, true)}
                        aria-label="close"
                        sx={{
                            color: "#ff0000b8 !important",
                        }}
                    >
                        <DoNotDisturbOnRoundedIcon
                            style={{
                                fontSize: 20,
                            }}
                        />
                    </IconButton>
                );
            }
        }

        return buttons;
    };

    const handleAddRemoveCondition = (param) => {
        setElIfSelects([""]);
        setElIfMin(1);
        setShowElIF(param);
        let obj = {};
        if (param) {
            obj["expected_result"] = conditionOptions[0].value;
            obj["is_if"] = false;
            obj["min"] = 1;
            obj["max"] = 1;
            obj["kpi"] = [""];
        }
        removeKpiCondition(tabId, param, obj);
    };

    const getFilteredOptions = () => {
        let selectedOptions = [];
        ifSelects?.forEach((ele) => {
            selectedOptions.push(ele);
        });

        elIfSelects?.forEach((ele) => {
            selectedOptions.push(ele);
        });

        selectedOptions = selectedOptions.filter(Boolean);

        return options?.filter((datum) => !selectedOptions.includes(datum.value));
    };

    const getBWFilteredOptions = (block) => {
        let selectedOptions = [...ifSelects, ...elIfSelects].filter(Boolean);

        let filteredOptions = options?.filter((item) => !selectedOptions.includes(item.value));

        if (block === "if") {
            return filteredOptions?.filter((item) => item.variableCategory === "KPI (OO)");
        }

        if (block === "elseIf") {
            if (isHairCare) {
                return filteredOptions?.filter((item) => ["KPI (OO)", "JAR", "Agreement KPI"].includes(item.variableCategory));
            }

            if (isSkinCare) {
                return filteredOptions?.filter((item) => ["KPI (OO)", "Agreement KPI"].includes(item.variableCategory));
            }
        }

        return filteredOptions;
    };

    return (
        <div
            style={{
                background: "#fff",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <label className="as-kpi-header liner-light-blue-background-2">KPI Selection Criteria</label>
            </div>

            <div
                style={{
                    display: "flex",
                    padding: "10px",
                    border: "1px solid #e8e8e8",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <div
                    style={{
                        width: "10%",
                        backgroundColor: "#ffffff",
                        textAlign: "center",
                        height: !showElIf && ifSelects.length === 1 ? "80px" : "30px",
                    }}
                >
                    <label className="as-kpi-label">IF</label>
                    {!showElIf && ifSelects.length === 1 ? (
                        <button
                            style={{
                                background: "grey",
                                outline: "none",
                                border: "none",
                                color: "#fff",
                                minHeight: "30px",
                                padding: "5px",
                                marginTop: "5px",
                                width: "100%",
                            }}
                            onClick={() => handleAddRemoveCondition(true)}
                        >
                            Add Condition
                        </button>
                    ) : (
                        ""
                    )}
                </div>
                <div
                    style={{
                        width: "42%",
                        margin: "0px 10px",
                    }}
                >
                    {/* Map through the selects array to dynamically render each Select component */}
                    {ifSelects.map((select, index) => (
                        <div
                            key={select.id}
                            style={{
                                display: "flex",
                                marginBottom: ifSelects.length > 1 ? "10px" : "0px",
                            }}
                        >
                            <div style={{ flexGrow: 1, width: "85%" }}>
                                <Select
                                    key={inputRefIf[index]}
                                    className="dialogue-dropdown"
                                    options={isBeautyAndWellbeing ? getBWFilteredOptions("if") : getFilteredOptions()}
                                    value={options.filter((ele) => ele.value === ifSelects[index])}
                                    placeholder={`KPI ${index + 1}`}
                                    onChange={(e) => handleSelectChange(e, index, "selectKpi", "if")}
                                />
                                <span
                                    style={{
                                        color: "#FF0000",
                                        margin: "2px 5px",
                                    }}
                                >
                                    {validation && validation.ifObj && validation.ifObj.kpi ? validation.ifObj.kpi : ""}
                                </span>
                            </div>

                            {/* Button to remove the corresponding select component */}
                            <div style={{ width: "15%", padding: "3px" }}>{renderAddRemoveKPIButtons("if", index, ifSelects)}</div>
                        </div>
                    ))}
                </div>
                <div
                    className={ifSelects.length === 1 ? "as-kpi-label" : ""}
                    style={{
                        width: ifSelects.length === 1 ? "10%" : "20%",
                    }}
                >
                    {ifSelects.length === 1 ? (
                        <label>IS</label>
                    ) : (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <label
                                    style={{
                                        width: "30%",
                                        textAlign: "center",
                                        padding: "10px",
                                    }}
                                >
                                    AT LEAST
                                </label>
                                <input
                                    ref={inputRef}
                                    type="text"
                                    name="ifMin"
                                    className="text-input-dialog as-input-field"
                                    placeholder=""
                                    disabled={false}
                                    value={ifMin}
                                    onChange={(e) => handleSelectChange(e.target.value, null, "inputMin", "if")}
                                    style={{
                                        width: "15%",
                                    }}
                                />
                                <label
                                    style={{
                                        width: "40%",
                                        textAlign: "center",
                                        padding: "10px",
                                    }}
                                >
                                    OUT OF
                                </label>
                                <input
                                    type="text"
                                    name="ifMin"
                                    className="text-input-dialog as-input-field"
                                    placeholder=""
                                    disabled={true}
                                    value={ifSelects.length}
                                    style={{
                                        width: "15%",
                                    }}
                                />
                            </div>
                            <span
                                style={{
                                    color: "#FF0000",
                                    margin: "2px 5px",
                                }}
                            >
                                {validation && validation.ifObj && validation.ifObj.min ? validation.ifObj.min : ""}
                            </span>
                        </>
                    )}
                </div>
                <div
                    style={{
                        width: ifSelects.length === 1 ? "38%" : "30%",
                        margin: "0px 10px",
                    }}
                >
                    <Select
                        className="dialogue-dropdown"
                        name={"ifCondition"}
                        placeholder={"Condition"}
                        value={conditionOptions[0]}
                        options={conditionOptions}
                    // onChange={(e) => handleSelectChange(e, 0, "condition", "if")}
                    />
                </div>
            </div>
            {showElIf ? (
                <div className="condition-block">
                    <IconButton
                        onClick={() => handleAddRemoveCondition(false)}
                        aria-label="close"
                        sx={{
                            position: "relative",
                            right: 0,
                            color: "#ff0000b8 !important",
                        }}
                        style={{
                            position: "absolute",
                            top: "-20px",
                            right: "-20px",
                        }}
                    >
                        <CancelRoundedIcon
                            style={{
                                fontSize: 25,
                            }}
                        />
                    </IconButton>
                    <div
                        style={{
                            display: "flex",
                            padding: "10px",
                            border: "1px solid #e8e8e8",
                            alignItems: "center",
                        }}
                    >
                        <div
                            className="as-kpi-label"
                            style={{
                                width: "10%",
                            }}
                        >
                            <label>Else IF</label>
                        </div>
                        <div
                            style={{
                                width: "42%",
                                margin: "0px 10px",
                            }}
                        >
                            {/* Map through the selects array to dynamically render each Select component */}
                            {elIfSelects.map((select, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        marginBottom: elIfSelects.length > 1 ? "10px" : "0px",
                                    }}
                                >
                                    <div style={{ flexGrow: 1, width: "85%" }}>
                                        <Select
                                            key={inputRef}
                                            className="dialogue-dropdown"
                                            options={isBeautyAndWellbeing ? getBWFilteredOptions("elseIf") : getFilteredOptions()}
                                            value={options.filter((ele) => ele.value === elIfSelects[index])}
                                            placeholder={`KPI ${index + 1}`}
                                            onChange={(e) => handleSelectChange(e, index, "selectKpi", "elseIf")}
                                            isDisabled={!isIfKpiSelected}
                                        />
                                        <span
                                            style={{
                                                color: "#FF0000",
                                                margin: "2px 5px",
                                            }}
                                        >
                                            {validation && validation.elseIfObj && validation.elseIfObj.kpi ? validation.elseIfObj.kpi : ""}
                                        </span>
                                    </div>

                                    {/* Button to remove the corresponding select component */}
                                    <div style={{ width: "15%", padding: "3px" }}>{renderAddRemoveKPIButtons("elseIf", index, elIfSelects)}</div>
                                </div>
                            ))}
                        </div>
                        <div
                            className={elIfSelects.length === 1 ? "as-kpi-label" : ""}
                            style={{
                                width: elIfSelects.length === 1 ? "10%" : "35%",
                            }}
                        >
                            {elIfSelects.length === 1 ? (
                                <label>IS</label>
                            ) : (
                                <>
                                    <div
                                        style={{
                                            display: "flex",
                                        }}
                                    >
                                        <label
                                            style={{
                                                width: "30%",
                                                textAlign: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            ATLEAST
                                        </label>
                                        <input
                                            ref={inputRef}
                                            type="text"
                                            name="elIfMin"
                                            className="text-input-dialog as-input-field"
                                            placeholder=""
                                            disabled={false}
                                            value={elIfMin}
                                            onChange={(e) => handleSelectChange(e.target.value, null, "inputMin", "elseIf")}
                                            style={{
                                                width: "35%",
                                            }}
                                        />
                                        <label
                                            style={{
                                                width: "40%",
                                                textAlign: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            OUT OF
                                        </label>
                                        <input
                                            type="text"
                                            name="ifMin"
                                            className="text-input-dialog as-input-field"
                                            placeholder=""
                                            disabled={true}
                                            value={elIfSelects.length}
                                            style={{
                                                width: "35%",
                                            }}
                                        />
                                    </div>
                                    <span
                                        style={{
                                            color: "#FF0000",
                                            margin: "2px 5px",
                                        }}
                                    >
                                        {validation && validation.elseIfObj && validation.elseIfObj.min ? validation.elseIfObj.min : ""}
                                    </span>
                                </>
                            )}
                        </div>
                        <div
                            style={{
                                width: elIfSelects.length === 1 ? "38%" : "10%",
                                margin: "0px 10px",
                            }}
                        >
                            <Select
                                className="dialogue-dropdown"
                                name={"elIfCondition"}
                                placeholder={"Condition"}
                                value={conditionOptions[0]}
                                options={conditionOptions}
                            // onChange={(e) => handleSelectChange(e, 0, "condition", "elseif")}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}
        </div>
    );
});

ActionStandardKPI.propTypes = {
    tabId: PropTypes.number,
    getAsKpiData: PropTypes.func,
    options: PropTypes.array,
    formData: PropTypes.array,
    // error: PropTypes.object,
    removeKpiCondition: PropTypes.func,
    validation: PropTypes.object,
    isHomeUseTest: PropTypes.bool,
};

export default ActionStandardKPI;
